import { Component, OnInit, Input, trigger, state, style, transition, animate, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'cm-a-propos',

    template: `
        <div class="ecran-a-propos text-justify" 
            [@afficherCacherEcran]="etatEcran">
            
            <div class="cadre-fermer" (click)="fermer()"> <img class="img image-fermer" src="./assets/images/croix.png"/> </div>

            <div class="cadre-defilement">

                <h3>À propos</h3>

                <hr>

                <p>Cette carte vous permet de découvrir les chapelles, les églises et les sanctuaires dédiés à la Vierge Marie à travers le monde. 
                Vous pouvez contribuer à enrichir ce site et ainsi nous aider à l'améliorer.
                </p>

                <p>
                Dans un premier temps, vous pouvez soumettre vos articles à l'équipe de Marie de Nazareth. Vous avez la possibilité, en tant que représentant 
                d'un sanctuaire, d'une chapelle, d'une église ou d'une institution consacrée à la Vierge Marie, de nous envoyer des photos (libres de droits) 
                avec des articles originaux donnant des détails sur l'histoire du sanctuaire, sa spiritualité, les miracles ou les apparitions qui s'y sont 
                produits, les dates de fêtes importantes dans l'année, l'adresse du site internet et toute autre information utile. Les articles doivent être 
                rédigés et illustrés de la manière suivante :
                </p>

                <ul>
                    <li>Une photo du sanctuaire pour la page principale, de préférence et en priorité une vue extérieure du sanctuaire ou de la statue de Notre Dame.</li>
                    <li>Un article de synthèse préliminaire de 12 lignes ou 80 mots au maximum, donnant un bref résumé de l'histoire du sanctuaire pour la page principale.</li>
                    <li>Dans un second temps, vous pouvez soumettre diverses photos, d'une dimension minimum de 360x360 pixels.</li>
                </ul>

                <p>
                Enfin, il est possible de préparer une série de textes plus longs sur l'histoire, la présentation, les informations connexes, les actualités, 
                les prières et les témoignages de témoins oculaires.
                </p>

                <p>
                Afin de faciliter la sélection de votre contribution, il est impératif d'envoyer votre dossier avec une note d'approbation émanant du prêtre de la 
                paroisse ou de l'autorité ecclésiastique locale, en précisant leurs coordonnées téléphoniques et les détails internet.
                </p>

            </div>
        </div>
    `,

    styles: [`
        .ecran-a-propos {
            position: absolute;
            top: 0;
            left: 60vw;
            width: calc(40vw - 60px);
            height: calc(100vh - 50px);
            background-color: white;
            border: 1px solid lightgray;
        }
        .cadre-defilement {
            padding: 30px 30px 30px 45px;
            height: calc(100vh - 50px - 50px);
            overflow-y: auto;
        }
        .cadre-fermer {
            height: 50px;
        }
        .image-fermer {
            position: relative;
            top: 10px;
            left: calc(100% - 40px);
            width: 25px;
            height: 25px;
            cursor: pointer;
        }
        h3 {
            margin-bottom: 40px;
        }


        @media (max-width: 800px), (max-height: 700px) { 
            .ecran-a-propos {
                left: 0;
                width: 100vw;
                height: 100vh;
                padding: 30px 20px 30px 20px;
            }
        }
    `],

     animations: [
        trigger('afficherCacherEcran', [
        state('visible', style({
        transform: 'translateX(0) scale(1, 1)'
        })),
        state('invisible', style({
            transform: 'translateX(100%) scale(0, 1)'
        })),
        transition('visible => invisible', animate('400ms ease-in-out')),
        transition('invisible => visible', animate('400ms ease-in-out'))
        ]),
    ]
})

export class AProposComponent implements OnInit {
    @Input() etatEcran: string;
    @Output() fermerEcran: EventEmitter<any> = new EventEmitter();

    constructor() {}

    ngOnInit() {
    }

    fermer() {
       this.fermerEcran.emit();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/a-propos.component.ts